import Vue from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import { Anniversary15PromoBanner } from '@widgets/anniversary15Promo';
import SpecialOfferBanner from './SpecialOfferBanner.vue';

useVueCompositionApi();

function initSpecialOfferBanner() {
    const containers = document.querySelectorAll('.js-special-offer-banner');
    const isAnniversaryPromo = !!window?.appConfig?.anniversary15Promo;

    containers.forEach(container => {
        if (container && !container.__vueInstance) {
            container.__vueInstance = new Vue({
                render: (h) => (isAnniversaryPromo
                    ? h(Anniversary15PromoBanner, { props: { variant: 'top' } })
                    : h(SpecialOfferBanner)),
            }).$mount(container);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecialOfferBanner);
} else {
    initSpecialOfferBanner();
}

export default initSpecialOfferBanner;
